import styled from '@cthings.co/styled-components';
import { media } from '@cthings.co/styles-utils';
import { Text } from '@bit/first-scope.text';
import { CommonButton } from '@cthings.co/buttons';
import { Select } from '../../../../components/universalSelect/Select';

import { colorFetchFDS as colorFetch } from '@cthings.co/styles-utils';
import { ThemeType } from '@cthings.co/styled-components';

const HORIZONTAL_GAP = 20;

export const InputsWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-top: 15px;
  gap: 0px ${HORIZONTAL_GAP}px;
  flex-wrap: wrap;

  ${media.phone} {
    flex-direction: column;
  }
`;

type InputsContainerProps = {
  flex: string;
};

export const HeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const InputsContainer = styled.div<InputsContainerProps>`
  position: relative;
  width: 100%;
  flex: ${({ flex }) => `${flex} ${flex} calc(${(100 * Number(flex)) / 2}% - ${HORIZONTAL_GAP / 2}px)`};
  min-width: calc(50% - 10px);
`;

export const StyledCommonButton = styled(CommonButton)`
  height: 32px;
  width: 116px;

  ${media.phone} {
    height: 40px;
    width: 100%;
  }
`;

export const StyledSelect = styled(Select)`
  margin: 0 0 14px 0;
`;

export const AreaTitle = styled.div`
  border-bottom: 1px solid;
  border-color: ${colorFetch('primary')};
  margin: 24px 0 12px 0;
`;

type ButtonType = typeof CommonButton & { theme: ThemeType };

export const SaveButton = styled(StyledCommonButton).attrs((props: ButtonType) => ({
  ...props,
  fontSize: '14px',
}))`
  margin: 0;

  ${media.phone} {
    margin: 0 0 10px 0;
  }
`;

export const CancelButton = styled(StyledCommonButton).attrs(
  ({
    theme: {
      colors: { primary: primaryColor, pureWhite, black1 },
    },
    ...rest
  }: ButtonType) => ({
    ...rest,
    fontSize: '14px',
    backgroundColor: pureWhite,
    borderColor: primaryColor,
    color: black1,
  }),
)`
  margin: 0 16px 0 0;

  ${media.phone} {
    margin: 0;
  }
`;

export const EditButton = styled(Text)`
  cursor: pointer;
  text-decoration-line: underline;
` as any; // @TODO fix type

export const SubtitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid;
  border-color: ${colorFetch('primary')};
  margin: 24px 0 18px 0;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  ${media.phone} {
    flex-direction: column-reverse;
  }
`;
